import { ItemPriority } from "../types/ItemPriority";

export default function formatPriority(priority: string) {
	const priorityMap: Record<ItemPriority["priority"], string> = {
		high: "Alta",
		medium: "Média",
		low: "Baixa",
		loading: "Carregando",
	};

	if (priority in priorityMap) {
		return priorityMap[priority as keyof typeof priorityMap];
	}

	return "desconhecida";
}
